var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBundles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 57.5004C77 58.9854 75.7623 60.4395 74.4992 61.1038L45.2648 77.5C44.6332 77.9689 42.8037 79 41.9747 79C41.1458 79 39.1309 78.4689 38.4993 78L9.49919 62.0004C8.23603 61.3361 6.99919 58.9854 6.99919 57.5004V23.4394C6.99919 21.9544 6.7367 20.1643 7.99986 19.5L39.4992 1.5C40.1308 1.03105 41.1458 0.5 41.9747 0.5C42.8037 0.5 43.8676 0.531466 44.4992 1.00041L74.4992 18.5004C75.7623 19.1648 77 20.5154 77 22.0004V57.5004ZM42.7648 8.07952L33.9992 13.5004L56.9992 27.0004L66.5 22.0004L42.7648 8.07952ZM16.9992 23.4394L41.9747 37.0004L50.9992 31.5004L27.4992 17.5004L16.9992 23.4394ZM13.2648 55.3592L38.4992 68.5679V43.0004L13.2648 29.0004V55.3592ZM69.9992 55.3592V29.0004L45.2648 43.0004V68.5679L69.9992 55.3592Z",
    fill: "#404041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundles);
export default __webpack_public_path__ + "static/media/bundles.a2f6b1556454218320ed50ff44dead71.svg";
export { ForwardRef as ReactComponent };